import FileRendererBlob from '@github-ui/file-renderer-blob'
import {SafeHTMLBox, type SafeHTMLString} from '@github-ui/safe-html'
import {Spinner} from '@primer/react'

import {useLoadRichDiffData} from '../../hooks/use-load-rich-diff-data'
import type {DiffEntryRenderInfo} from '../../types/commit-types'

export function RichDiff({
  commitOid,
  path,
  proseDiffHtml,
  fileRendererInfo,
}: {
  commitOid: string
  path: string
  proseDiffHtml?: SafeHTMLString
  fileRendererInfo?: DiffEntryRenderInfo
}) {
  const {loaded, richDiffData} = useLoadRichDiffData(commitOid, {proseDiffHtml, fileRendererInfo}, path)

  if (!loaded) {
    return (
      <div className="d-flex flex-justify-center p-4">
        <Spinner size="large" />
      </div>
    )
  }

  if (richDiffData.proseDiffHtml) {
    return (
      <div className="prose-diff position-relative">
        <SafeHTMLBox html={richDiffData.proseDiffHtml} />
      </div>
    )
  } else if (richDiffData.fileRendererInfo) {
    return (
      <FileRendererBlob
        identityUuid={richDiffData.fileRendererInfo.identityUuid}
        type={richDiffData.fileRendererInfo.renderType}
        size={richDiffData.fileRendererInfo.size}
        url={richDiffData.fileRendererInfo.displayUrl}
      />
    )
  } else {
    return <div className="d-flex flex-justify-center p-4">This rich diff is not supported at the moment.</div>
  }
}

try{ RichDiff.displayName ||= 'RichDiff' } catch {}